import { render, staticRenderFns } from "./ProbeDetailTable.vue?vue&type=template&id=c29ba0f0&scoped=true&"
import script from "./ProbeDetailTable.vue?vue&type=script&lang=js&"
export * from "./ProbeDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29ba0f0",
  null
  
)

export default component.exports